import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  PatternlibSidebar,
  PatternlibSidebarItem,
} from "@liebherr/patternlib-react";
import PropTypes from "prop-types";
import { pushToDataLayer } from "../../helpers/helpers";

const Sidebar = ({ activeTab }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const navigationClickGA = (navigationArea, clickedElement) => {
    const eventName = "navigation_click";
    const pagePath = location.pathname;
    const pageType = "home";
    const language =
      i18n.language === "de-DE" || i18n.language === "de" ? "de-DE" : "en-EN";
    const navigation_area = navigationArea;
    const clicked_element = clickedElement;
    let props = {
      pagePath,
      pageType,
      language,
      navigation_area,
      clicked_element,
    };

    pushToDataLayer(eventName, props);
  };

  const toPage = (tabId) => () => {
    switch (tabId) {
      case 0:
        navigationClickGA("sidebar", t("Sidebar.myConfigs"));
        navigate("/myconfigs");
        break;
      // case 1:
      //   navigate("/profile");
      //   break;
      case 1:
        navigationClickGA("sidebar", t("Sidebar.contact"));
        navigate("/contact");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <PatternlibSidebar collapse="true">
      <PatternlibSidebarItem
        icon-name="settings"
        label={t("Sidebar.myConfigs")}
        active={activeTab === 0 ? true : false}
        onClick={toPage(0)}
      ></PatternlibSidebarItem>
      {/* <PatternlibSidebarItem
        icon-name="user"
        label={t("Sidebar.profile")}
        active={activeTab === 1 ? true : false}
        onClick={toPage(1)}
      ></PatternlibSidebarItem> */}
      <PatternlibSidebarItem
        icon-name="phone"
        label={t("Sidebar.contact")}
        active={activeTab === 1 ? true : false}
        onClick={toPage(1)}
      ></PatternlibSidebarItem>
    </PatternlibSidebar>
  );
};

Sidebar.propTypes = {
  activeTab: PropTypes.number,
};

Sidebar.defaultProps = {
  activeTab: 0,
};

export default Sidebar;
